export const BOOT_SCENE_KEY = 'BootScene';
export const WORLD_SCENE_KEY = 'WorldScene';
export const HUD_SCENE_KEY = 'HudScene';
